import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_PROCESOS_JURIDICOS
export default class TiposIncidenciasService {
  listar () {
    return http.get(`${baseUrl}/tipos-procesos/paginate`)
  }
}
